import { EFlatRoomCounts } from '../../common/utils/types';
import { EMyHomeEstimationTargets } from '../types/estimationTarget';
import { getTrackMyHomeAreaPick, trackMyHomeFlatNumberPick, trackMyHomeRoomsCountClick } from './tracking';

interface ISubmitAnalyticsProps {
  flatNumber?: number;
  area?: number;
  roomsCount?: EFlatRoomCounts;
  isNewbuilding?: boolean;
}

export const useSubmitAnalyticsFormWithRoomNumber = () => {
  return ({ flatNumber, area, roomsCount, isNewbuilding }: ISubmitAnalyticsProps) => {
    if (area) {
      // Запрос по номеру квартиры вернул результат
      trackMyHomeFlatNumberPick({
        estimationTarget: EMyHomeEstimationTargets.flat,
        value: flatNumber,
        auto: true,
        isNewbuilding,
      });

      // Площадь была заполнена из саджеста
      getTrackMyHomeAreaPick({
        estimationTarget: EMyHomeEstimationTargets.flat,
        value: area,
        auto: true,
        isNewbuilding,
      })();

      if (roomsCount) {
        // Комнатность была заполнена из саджеста
        trackMyHomeRoomsCountClick({
          estimationTarget: EMyHomeEstimationTargets.flat,
          value: roomsCount,
          auto: true,
          isNewbuilding,
        });
      }
    } else {
      // Запрос по номеру квартиры не вернул ничего
      trackMyHomeFlatNumberPick({
        estimationTarget: EMyHomeEstimationTargets.flat,
        value: flatNumber,
        auto: false,
      });
    }
  };
};
